import { useMantineTheme, type MantineTheme } from '@mantine/core';
import { useMediaQuery } from 'react-responsive';

type Breakpoint = keyof MantineTheme['breakpoints'];

// Current minimum width for the menu to be displayed, with predictions & marketplace enabled
export const MENU_BREAKPOINT = 1216;

const useIsLargerThan = (breakpoint: Breakpoint) => {
  const theme = useMantineTheme();
  return useMediaQuery({ minWidth: theme.breakpoints[breakpoint] });
};

const useIsSmallerThan = (breakpoint: Breakpoint) => {
  const theme = useMantineTheme();
  return useMediaQuery({ maxWidth: theme.breakpoints[breakpoint] - 1 });
};

export const useIsMenuBreakpoint = () => useMediaQuery({ maxWidth: MENU_BREAKPOINT - 1 })

// ---------- minWidth queries ----------
export const useIsBiggerThanDesktop = () => useIsLargerThan('xl');

export const useIsBiggerThanNotebook = () => useIsLargerThan('lg');

export const useIsBiggerThanTablet = () => useIsLargerThan('md');

export const useIsBiggerThanMobile = () => useIsLargerThan('sm');

// ---------- maxWidth queries ----------
// 1400px
export const useIsDesktop = () => useIsSmallerThan('xl');

// 1200px
export const useIsNotebook = () => useIsSmallerThan('lg');

// 992px
export const useIsTablet = () => useIsSmallerThan('md');

// 768px
export const useIsMobile = () => useIsSmallerThan('sm');

// 480px
export const useIsMobilePortrait = () => useIsSmallerThan('xs');
